import React, { createContext, useReducer, useEffect, useState } from "react";

import { useDisclosure } from "@chakra-ui/react";
import { reducer } from "./reducer";
import { uniq, map } from "lodash";

import constants from "config/constants.json";

const { FETCH_ROLES_URL } = constants;

export const AppContext = createContext();

export const ContextWrapper = ({ children }) => {
  const initialItems = { count: 1 };

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [hasError, setHasError] = useState(true);
  const [hasEmailError, setHasEmailError] = useState(false);
  const [hasMobileError, setHasMobileError] = useState(false);

  const [isFetchingRoles, setIsFetchingRoles] = useState(false);

  const [availableRoles, setAvailableRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);

  const [itemIndex, setItemIndex] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);

  const [counter, dispatch] = useReducer(reducer, initialItems);
  const [consumer, setConsumer] = useState(true);
  const [visionCardTrigger, setVisionCardTrigger] = useState(false);
  const [HomePageTab, setHomePageTab] = useState(1);
  const [lang, setLang] = useState(2);

  const [accessToken, setAcesstoken] = useState("");
  const [msg, setMsg] = useState("");
  const [showMsgBar, setShowMsgBar] = useState(false);
  const [msgType, setMsgType] = useState("");

  const [openChtDemo, setOpenChtDemo] = useState(false);
  const [demoLink, setDemoLink] = useState("");

  const [info, setInfo] = useState({
    timestamp: new Date().toLocaleString(),
    deliveryAddress: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    state: "",

    message: "",
    timestamp: new Date().toLocaleString(),

    lga: "",
  });

  const resetInfo = () => {
    setInfo({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      deliveryAddress: "",
      lga: "",
      state: "",
      message: "",
      timestamp: new Date().toLocaleString(),
    });

    setHasEmailError(false);
    setHasMobileError(false);

    // reset tab
    setTabIndex(0);
    setHasError(true);
  };

  const saveAccessToken = token => {
    setAcesstoken(token);
  };

  const showMsg = (msg, msgType) => {
    // msgType can be "success" for success for success messages and "error" for error messages
    setMsg(msg);
    setMsgType(msgType);
    setShowMsgBar(true);
  };

  const hideMsgBar = () => {
    setShowMsgBar(false);
  };

  const openDemo = () => {
    setOpenChtDemo(true);
  };

  const closeDemo = () => {
    setOpenChtDemo(false);
  };

  const closeAndReset = () => {
    onClose();
    resetInfo();
  };

  const addToCart = index => {
    setItemIndex(index);
    onOpen();
  };

  const showBussness = () => {
    setConsumer(false);
  };
  const showConsumer = () => {
    setConsumer(true);
  };

  const handleTabsChange = index => {
    setTabIndex(index);
  };

  useEffect(() => {
    setIsFetchingRoles(true);

    setAvailableRoles(
      JSON.parse(localStorage.getItem("nomba-available-roles") || "[]")
    );
    setDepartments(
      JSON.parse(localStorage.getItem("nomba-departments") || "[]")
    );
    setLocations(JSON.parse(localStorage.getItem("nomba-locations") || "[]"));

    fetch(FETCH_ROLES_URL)
      .then(res => res.json())
      .then(({ Results: roles }) => {
        const newRoleLocations = uniq(
          map(roles, role => `${role.City}, ${role.Country}`)
        );

        const newRoleDepartments = uniq(map(roles, "Department"));

        const newAvailableRoles = map(roles, role => ({
          slug: role.Title.replace(/[^a-z0-9 ]/gi, "")
            .split(/ +/g)
            .join("-")
            .toLowerCase(),
          location: `${role.City}, ${role.Country}`,
          description: role.MetatagDescription,
          metaTagTitle: role.MetatagTitle,
          department: role.Department,
          markup: role.Description,
          title: role.Title,
          id: role.Id,
        }));

        localStorage.setItem(
          "nomba-available-roles",
          JSON.stringify(newAvailableRoles)
        );
        localStorage.setItem(
          "nomba-departments",
          JSON.stringify(newRoleDepartments)
        );
        localStorage.setItem(
          "nomba-locations",
          JSON.stringify(newRoleLocations)
        );

        setAvailableRoles(newAvailableRoles);
        setDepartments(newRoleDepartments);
        setLocations(newRoleLocations);

        setIsFetchingRoles(false);
      });
  }, []);

  useEffect(() => {
    setHasError(
      Object.keys(info)
        .map(r => !!info[r].length)
        .includes(false)
    );
  }, [info]);

  return (
    <AppContext.Provider
      value={{
        lang,
        setLang,
        onOpen,
        isOpen,
        onClose,
        closeAndReset,

        info,
        setInfo,
        resetInfo,

        counter,
        dispatch,

        hasError,
        setHasError,

        hasEmailError,
        setHasEmailError,

        hasMobileError,
        setHasMobileError,

        itemIndex,
        addToCart,

        tabIndex,
        setTabIndex,
        handleTabsChange,
        consumer,
        showBussness,
        showConsumer,
        visionCardTrigger,
        setVisionCardTrigger,
        HomePageTab,
        setHomePageTab,
        saveAccessToken,
        accessToken,

        isFetchingRoles,
        availableRoles,
        departments,
        locations,
        msg,
        showMsg,
        msgType,
        hideMsgBar,
        showMsgBar,
        openDemo,
        closeDemo,
        openChtDemo,
        setOpenChtDemo,
        demoLink,
        setDemoLink,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
